export default __webpack_public_path__ + "static/media/tres.1e838631.jpg";